// Data civil no fuso da operação, do lado do client.
//
// A primitiva (o offset e `diaCivilNaFazenda`) mora em `shared/data-fazenda.ts`:
// o servidor precisa da mesma conta, e duas cópias da constante é como o bug do
// `iniciadoEm` em UTC nasceu. Aqui ficam só os atalhos que o client usa.
//
// O servidor tem `server/lib/data-tz.ts` (com Intl e fallback) para o caso geral
// de "data civil num fuso qualquer"; estes atalhos assumem a Boa Vista.

import { OFFSET_FAZENDA_MS, somarDiasCivis } from "@shared/data-fazenda";

export { diaCivilNaFazenda, somarDiasCivis } from "@shared/data-fazenda";

/** Hoje na fazenda (YYYY-MM-DD). */
export function hojeNaFazenda(): string {
  return new Date(Date.now() - OFFSET_FAZENDA_MS).toISOString().slice(0, 10);
}

/** Ontem na fazenda — o alvo padrão do boletim diário, o mesmo do servidor. */
export function ontemNaFazenda(): string {
  return somarDiasCivis(hojeNaFazenda(), -1);
}

/** Amanhã na fazenda — usado pelas ações rápidas do Backlog (spec §6.3). */
export function amanhaNaFazenda(): string {
  return somarDiasCivis(hojeNaFazenda(), 1);
}
